exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "delegated-card-request .delegated-card-request-container{padding-left:10px;margin-top:5px}delegated-card-request .delegated-card-request-container .name{font-size:14px;color:#0072c9;line-height:12px;font-weight:400;margin-top:0}delegated-card-request .delegated-card-request-container .icons-container{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;height:16px}delegated-card-request .delegated-card-request-container .icons-container .status-icon{margin-right:10px;font-size:20px}delegated-card-request .delegated-card-request-container .icons-container .status-icon .without-icon{background-color:#dddfe2;display:block;width:20px;height:20px;border-radius:100%;margin-top:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardRequest/delegatedCardRequest.scss
// module id = 1717
// module chunks = 0